import React, { useState } from 'react';
import CommonCard from '../atoms/CommonCard';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { service } from '../../../services/AxiosServices';
import ConfirmDialog from '../atoms/ConfirmDialog'; // Make sure to import ConfirmDialog

// Structure of an Agent object
interface Agent {
  id: string;
  name: string;
  updatedOn: string;
  createdBy: string;
  usedLLM: string;
}

// Props that the AgentCard component expects
interface AgentCardProps {
  agent: Agent;
  crewId: string;
  crewName?: string;
  onDelete: (id: number) => void;
}

// Functional Component for displaying an agent
const AgentCard: React.FC<AgentCardProps> = ({ agent, crewName, crewId, onDelete }) => {
  const navigate = useNavigate();
  const [showDelete, setShowDelete] = useState(false);

  const confirmDelete = () => {
    setShowDelete(true);
  };

  const handleDelete = async () => {
    try {
      const response = await service(
        "api/agent/delete",
        "delete",
        null,
        "application/json",
        agent.id
      );

      toast.success('Agent deleted successfully!', { autoClose: 2000 });
      onDelete(Number(agent.id));
    } catch (err) {
      console.log(err);
      toast.error('Failed to delete agent');
    } finally {
      setShowDelete(false);
    }
  };

  return (
    <>
      <CommonCard
        id={agent.id}
        title={agent.name}
        entityType="Agent"
        details={[
          { label: 'Updated on', value: agent.updatedOn },
          { label: 'Created by', value: agent.createdBy },
          { label: 'Used LLM', value: agent.usedLLM },
          { label: 'Agent ID', value: `00${agent.id}` },
        ]}
        onView={() => navigate(`/agent_detail/${crewId}/${agent.id}`, { state: { crewName } })}
        onEdit={() => navigate(`/edit_agent/${crewId}/${agent.id}`, { state: { crewName } })}
        onDelete={confirmDelete} 
        permissionName = {'manage_agents'}
      />
      <ConfirmDialog
        show={showDelete}
        onHide={() => setShowDelete(false)}
        onConfirm={handleDelete}
        title="Confirm delete"
        body={`Are you sure you want to delete the ${agent.name}?`}
        confirmText="Delete"
      />
    </>
  );
};

export default AgentCard;